import { type IBaseWidget } from '../../widgets/IBaseWidget.ts';
import { type IPdfVisibilityDirective } from './IPdfVisibilityDirective.ts';

/**
 * Estrae e tipizza la configurazione della direttiva
 * di visibilità per i pdf dal widget
 */
export function extractPdfVisibility(
  widget: IBaseWidget,
): IPdfVisibilityDirective | undefined {
  return widget.directives?.pdfVisibility;
}
